import React, { useEffect as uEffect } from 'react'

import { useState as uState } from "react";
import "../chart.scss";
import {
    LineChart,
    Line,
    Legend,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from "recharts";


export default function productLineChart({ aspect, title }) {

    const [monthProducts, setMonthProducts] = uState("")
    const [monthProducts2, setMonthProducts2] = uState("");
    const [monthProducts3, setMonthProducts3] = uState("");
    const [monthProducts4, setMonthProducts4] = uState("");
    const [monthProducts5, setMonthProducts5] = uState("");
    const [monthProducts6, setMonthProducts6] = uState("");


    var currentDate = new Date(); // get the current date

    var dates = [];

    for (var i = 0; i < 6; i++) {
        // loop through the previous six months
        var previousMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i
        ); // get the date object for the previous month
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
        var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

        // if the previous month is in the previous year, subtract 1 from the year
        if (previousMonth.getMonth() > currentDate.getMonth()) {
            previousMonthYear -= 0;
        }

        var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
        dates.push(obj); // add the object to the data array
    }


    const month1 = () => {
        fetch("http://localhost:8000/products/productMonthCount", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts(data));
    }
    const month2 = () => {
        fetch("http://localhost:8000/products/productMonthCount2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts2(data));
    }
    const month3 = () => {
        fetch("http://localhost:8000/products/productMonthCount3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts3(data));
    }
    const month4 = () => {
        fetch("http://localhost:8000/products/productMonthCount4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts4(data));
    }
    const month5 = () => {
        fetch("http://localhost:8000/products/productMonthCount5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts5(data));
    }
    const month6 = () => {
        fetch("http://localhost:8000/products/productMonthCount6", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthProducts6(data));
    }
    const fetchedData = [
        { name: dates[5].name, Year: dates[5].Year, Products: monthProducts6 },
        { name: dates[4].name, Year: dates[4].Year, Products: monthProducts5 },
        { name: dates[3].name, Year: dates[3].Year, Products: monthProducts4 },
        { name: dates[2].name, Year: dates[2].Year, Products: monthProducts3 },
        { name: dates[1].name, Year: dates[1].Year, Products: monthProducts2 },
        { name: dates[0].name, Year: dates[0].Year, Products: monthProducts },
    ];
    uEffect(() => {
        month1()
        month2()
        month3()
        month4()
        month5()
        month6()
    },[])




  return (
      <>
      
          <div className="chart">
              <div className="title">{title}</div>
                  <LineChart width={1030} height={250} data={fetchedData}
                      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis dataKey="Products" />
                      <Tooltip />
                      <Legend />
                  <Line type="monotone" dataKey="Products" stroke="#06038D" />
                      {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
                  </LineChart>
          </div>  
      
      
      </>
  )
}




